import React, { Dispatch, SetStateAction } from "react"
import {
  CompanyAttribute,
  OrderAddress,
  OrderAddressesModificationUpdateDataAddress
} from "lib/types/generated/graphql-types"
import { Container } from "./AddressInfo.styled"
import ListEntry from "../Ui/ListEntry"
import { getCountryName } from "helpers/countries"
import OrderCompany from "../OrderOverview/OrderCompany"
import { Maybe } from "@graphql-tools/utils"
import { IconWrapper } from "./CustomerHeader.styled"
import { ReactComponent as ChevronUp } from "images/icons/chevron-up.svg"

type Props = {
  address: OrderAddress | OrderAddressesModificationUpdateDataAddress
  showCustomerInfo: boolean
  label?: string
  company?: Maybe<CompanyAttribute>
  setExpanded?: Dispatch<SetStateAction<boolean>>
  expandableAddress?: boolean
}

const AddressInfo = ({
  address,
  showCustomerInfo,
  label,
  company,
  setExpanded,
  expandableAddress
}: Props) => {
  return (
    <>
      <Container>
        {label && <b>{label}</b>}
        {showCustomerInfo && (
          <>
            <ListEntry label={"Name"} value={`${address?.givenName} ${address?.familyName}`} />
            <ListEntry label={"Email"} value={address?.email ?? ""} />
            <ListEntry label={"Phone"} value={address?.telephoneNumber ?? ""} />
          </>
        )}
        <ListEntry label={"Street Address"} value={address?.streetAddress ?? ""} />
        {address?.streetAddress2 && (
          <ListEntry label={"Street Address 2"} value={address?.streetAddress2 ?? ""} />
        )}
        <ListEntry label={"Postal code"} value={address?.postalCode ?? ""} />
        <ListEntry label={"City"} value={address?.city ?? ""} />
        {address?.stateOrProvince && (
          <ListEntry label={"State"} value={address?.stateOrProvince ?? ""} />
        )}
        <ListEntry label={"Country"} value={getCountryName(address?.country ?? "") ?? ""} />
        {address?.pcc && <ListEntry label={"Pcc"} value={address?.pcc ?? ""} />}
        <OrderCompany company={company} />
        {expandableAddress && (
          <IconWrapper
            $expanded={expandableAddress}
            onClick={() => setExpanded && setExpanded(false)}
          >
            <div>
              Hide address <ChevronUp />
            </div>
          </IconWrapper>
        )}
      </Container>
    </>
  )
}

export default AddressInfo
